<!-- bbs > 타임라인 전체보기 -->
<template>
  <Loading v-if="isLoading" />
  <div class="content-wrap am-page-wrap" :class="amPage">
    <div class="navi-area">
      <div class="m-navi-top">
        <c-btn01 :btnText="t('message.goToHome')" @click="utils.movePage('/actionManagement')"/>
      </div>
      <NaviBox @closeMobileMenu="amListOpen"/>
    </div>
    <div class="page2">
      <div class="tit-group02 mo-home-add">
        <BtnIcon class="btn-ico-home" @click="utils.movePage('/actionManagement')"></BtnIcon>
        <h2 class="tit">{{t('message.timeline')}}
          <div class="pc-view srch-txt">
            <div class="txt01">{{ t('message.searchResult')?t('message.searchResult'):'검색결과' }}</div>
            <div class="txt02">{{ items.length }}{{t('message.count')}}</div>
          </div>
        </h2>
        <div class="filter-btn-group">
          <v-btn class="reset" :class="filterDiv" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
          <v-btn class="filter" @click="filterOpen" :class="filterDiv">{{t('message.filter')}}</v-btn>
          <div class="navi-btn">
            <v-btn @click="amListOpen"/>
          </div>
        </div>
        <div class="mo-view srch-txt">
          <div class="txt01">{{ t('message.searchResult')?t('message.searchResult'):'검색결과' }}</div>
          <div class="txt02">{{ items.length }}개</div>
        </div>
      </div>
      <div class="content-box">
        <div class="sort-group" :class="filterDiv">
          <div class="sort-row ty01">
            <div class="wl">
              <div class="inner-row">
                <div class="txt01">{{t('message.period')}}</div>
                <div class="date-sort">
                  <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
                  <div class="txt02">~</div>
                  <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
                </div>
                <div class="date-sort">
                  <c-btn02 :btnText="t('message.today')" class="ty01" @click="onClickDate('week')"/>
                  <c-btn02 :btnText="t('message.quarter')" class="ty01" @click="onClickDate('quarter')"/>
                  <c-btn02 :btnText="t('message.year2')" class="ty01" @click="onClickDate('year')"/>
                </div>
                <div class="date-sort">
                  <div class="txt03">{{t('message.viewSupportiveFeedbackOnly')}}</div>
                  <v-switch v-model="isGoodType" inset hide-details true-value="Y" false-value="N" ></v-switch>
                </div>
              </div>
              <div class="inner-row">
                <Select v-bind="typeSelect" v-model="typeModel"/>
                <Select v-bind="deptSelect" v-model="deptModel" v-if="typeModel=='3'"/>
                <Select v-bind="posSelect" v-model="posModel"/>
                <Select v-bind="monitoringSelect" v-model="monitoringModel"/>
                <Select v-bind="behaviorSelect" v-model="behaviorModel"/>
                <Select v-bind="shiftSelect" v-model="shiftModel"/>
                <Select v-bind="progressSelect" v-model="progressModel"/>
                <Select v-bind="photoSelect" v-model="photoModel"/>
              </div>
            </div>
            <div class="wr">
              <c-btnText01 :btnText="t('message.minimize')" class="ty02" @click="onClickNormal"/>
              <c-btnLine01 :btnText="t('message.download')" class="sm" @click="onClickDownload" v-if="user.roles != 'USER'"/>
            </div>
          </div>
        </div>
        <div class="slider-group all">
          <v-slide-group
          >
            <v-slide-group-item
              v-for="(item,i) in items"
              :key="i"
              v-slot="{ isSelected, toggle }"
            >
              <v-card
                :class="item.type=='2'?'ty01':''"
                @click="toggle"
              >
                <div class="slider-item">
                  <div class="img-slider">
                    <v-carousel
                    >
                      <v-carousel-item
                        v-for="(item2,i) in item.timelineImages"
                        :key="i"
                        :src="utils.getBaseUrl('timeline', item2.filePath)"
                        cover
                        @click="onClickPreview(item2)"
                      ></v-carousel-item>
                    </v-carousel>
                  </div>
                  <div @click="onClickDetail(item)">
                    <div class="txt-group">
                      <div class="txt ell01">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
                      <div class="txt2">{{ item.regDateFormat }}</div>
                    </div>
                    <ul class="txt-group2">
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.monitoringBehavior')}}</div>
                        <div class="txt ell01">{{ item.behaviorTitle }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.location')}}</div>
                        <div class="txt ell01">{{ item.placeName }}</div>
                      </li>
                      <li>
                        <div class="tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
                        <div class="txt ell01">{{ item.situation }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.cause')}}</div>
                        <div class="txt ell01">{{ item.cause }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.correctiveActionDetails')}}</div>
                        <div class="txt ell01">{{ item.action }}</div>
                      </li>
                      <li>
                        <div class="tit">{{item.type=='1'?t('message.correctiveActionTarget'):t('message.praiseTarget')}}</div>
                        <div class="txt ell01">{{ item.targetText }}</div>
                      </li>
                      <li v-if="item.actionYn=='Y'">
                        <div class="tit">{{t('message.actionDeadline')}}</div>
                        <div class="txt ell01">{{ item.goalDate }}</div>
                      </li>
                      <li v-if="item.type=='1'">
                        <div class="tit">{{t('message.progressStatus')}}</div>
                        <div class="txt2 c01">{{ item.statusText }}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </v-card>
            </v-slide-group-item>
          </v-slide-group>
        </div>
      </div>
    </div>
  </div>
  <AmDialog01 v-model="detailPopupModel" @close="detailPopupModel=false" @delete="deleteAmDialog"/>
  <DialogImgView v-model="previewDialog" @close="previewDialog=false" :src="previewSrc"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import CompanyService from "@/services/company.service";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useI18n } from 'vue-i18n';
import quarterOfYear from "dayjs/plugin/quarterOfYear";
const { t } = useI18n();

//plugin
dayjs.extend(quarterOfYear)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const isLoading = ref(false)
const snackbar = ref(false)
const snackText = ref('')
const detailPopupModel = ref(false)
const previewDialog = ref(false)
const startDate = ref('')
const endDate = ref('')
const typeModel = ref('1')
const deptModel = ref('')
const posModel = ref('')
const monitoringModel = ref('')
const behaviorModel = ref('')
const shiftModel = ref('')
const progressModel = ref('')
const photoModel = ref('')
const allItems = ref([])
const items = ref([])
const previewSrc = ref('')
const isGoodType = ref("N")
const user:any = ref(JSON.parse(localStorage.getItem('user')))

//ui
const typeSelect = computed(() =>( {items: [{name:t('message.individualViewUnit'), value:'1'},{name:t('message.departmentViewUnit'), value:'2'},{name:t('message.organizationViewUnit'), value:'3'}]} ))
const deptSelectAdd = ref([])
const deptSelect = computed(() =>( {items: [{name:t('message.department')+t('message.select'), value:''}, ...deptSelectAdd.value]} ))
const posSelectAdd = ref([])
const posSelect = computed(() =>( {items: [{name:t('message.position')+t('message.select'), value:''}, ...posSelectAdd.value]} ))
const monitoringSelectAdd = ref([])
const monitoringSelect = computed(() =>( {items: [{name:t('message.monitoring')+t('message.select'), value:''}, ...monitoringSelectAdd.value]} ))
const behaviorSelectAdd = ref([])
//const behaviorSelect = computed(() =>( {items: [{name:t('message.behavior')+t('message.select'), value:''}, ...behaviorSelectAdd.value]} ))
const behaviorSelect = computed(() => {
  const filtered = monitoringModel.value ? behaviorSelectAdd.value.filter( item => Number(item.monitoringIdx) === Number(monitoringModel.value)) : behaviorSelectAdd.value
  return { items: [ { name: t('message.behavior') + t('message.select'), value: '' }, ...filtered ] }
})
const shiftSelectAdd = ref([])
const shiftSelect = computed(() =>( {items: [{name:t('message.shiftWork')+t('message.select'), value:''}, ...shiftSelectAdd.value]} ))
const progressSelect = computed(() =>( {items:
    [{name:t('message.progressStatus'), value:''},
    {name:t('message.ready'), value:'1'},
    {name:t('message.inProgress'), value:'2'},
    {name:t('message.onHold'), value:'3'},
    {name:t('message.complete'), value:'4'}]} ))
const photoSelect = computed(() =>( {items: [{name:t('message.all'), value:''}, {name:t('message.withPhoto'), value:'Y'}, {name:t('message.withoutPhoto'), value:'N'} ]} ))

//watch
watch(startDate, (newObj) => {
  onClickSearch()
})
watch(endDate, (newObj) => {
  onClickSearch()
})
watch(typeModel, (newObj) => {
  onClickSearch()
})
watch(deptModel, (newObj) => {
  onClickSearch()
})
watch(posModel, (newObj) => {
  onClickSearch()
})
watch(monitoringModel, (newObj) => {
  behaviorModel.value = ''
  onClickSearch()
})
watch(behaviorModel, (newObj) => {
  onClickSearch()
})
watch(shiftModel, (newObj) => {
  onClickSearch()
})
watch(progressModel, (newObj) => {
  onClickSearch()
})
watch(photoModel, (newObj) => {
  onClickSearch()
})
watch(isGoodType, (newObj) => {
  if(newObj == 'Y')
    items.value = _.filter(allItems.value, {type:'2'})
  else
    items.value = allItems.value
})

//hook
onMounted(() => {
  onClickDate('week')
  //const user = JSON.parse(localStorage.getItem('user'))
  const companyIdx = localStorage.getItem('companyIdx')
  let params = {idx: 0, companyIdx: companyIdx}
  CompanyService.getCompanyTreeList(params).then(
    (response) => {
      let deptList = _.filter(response.result, {treeType:'dept'})
      let posList = _.filter(response.result, {treeType:'pos'})
      _.forEach(deptList, function (item){
        deptSelectAdd.value.push({name:item.treeName, value:item.idx})
      })
      _.forEach(posList, function (item){
        posSelectAdd.value.push({name:item.treeName, value:item.idx})
      })
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  let params2 = {companyIdx: companyIdx, actionType:'1'}
  BbsService.getMonitoringFilter(params2).then(
    (response) => {
      //모니터링{{t('message.filter')}}
      let monitoringList = response.result.monitoringList
      _.forEach(monitoringList, function (item){
        monitoringSelectAdd.value.push({name:item.monitoringTitle, value:item.idx})
      })
      //행동{{t('message.filter')}}
      let behaviorList = response.result.behaviorList
      _.forEach(behaviorList, function (item){
        behaviorSelectAdd.value.push({name:item.behaviorTitle, value:item.idx, monitoringIdx:item.monitoringIdx})
      })
      //교대조{{t('message.filter')}}
      let shiftList = response.result.shiftList
      _.forEach(shiftList, function (item){
        shiftSelectAdd.value.push({name:item.shiftName, value:item.idx})
      })
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  typeModel.value = storeRef.timelineType.value?storeRef.timelineType.value:typeModel.value
  storeRef.timelineType.value = '1'
  onClickSearch()
})

//모니터링 메뉴 열고 닫기
const amPage = ref('naviOff')
function amListOpen(){
  if(amPage.value == 'naviOff')
    amPage.value = 'naviOn'
  else
    amPage.value = 'naviOff'
}
//{{t('message.filter')}} 메뉴 열고 닫기
const filterDiv = ref('off')
function filterOpen(){
  if(filterDiv.value == 'off')
    filterDiv.value = 'on'
  else
    filterDiv.value = 'off'
}

function onClickPreview(item){
  previewSrc.value = utils.getBaseUrl('timeline', item.filePath)
  previewDialog.value = true
}

function onClickDetail(item){
  storeRef.popupIdx.value = item.idx
  detailPopupModel.value = true
}

function onClickDate(type){
  let end = dayjs().format('YYYY-MM-DD')
  let start = dayjs().format('YYYY-MM-DD')
  if(type == 'quarter') {
    end = dayjs().endOf('quarter').format('YYYY-MM-DD')
    start = dayjs().startOf('quarter').format('YYYY-MM-DD')
  }
  else if(type == 'year') {
    end = dayjs().endOf('year').format('YYYY-MM-DD')
    start = dayjs().startOf('year').format('YYYY-MM-DD')
  }
  else if(type == 'week') {
    end = dayjs().format('YYYY-MM-DD')
    start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  }

  startDate.value = start.toString()
  endDate.value = end.toString()
}

function onClickSearch(){
  isLoading.value = true
  const companyIdx = JSON.parse(localStorage.getItem('companyIdx'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    filterType:typeModel.value,
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    monitoringIdx:monitoringModel.value,
    behaviorIdx:behaviorModel.value,
    shiftIdx:shiftModel.value,
    status:progressModel.value,
    companyIdx:companyIdx,
    photoYn:photoModel.value,
    isTemp:'N'
  }

  TimelineService.getTimelineList(params).then(
    (response) => {
      isLoading.value = false
      //타임라인
      allItems.value = response.result
      _.forEach(allItems.value, function(val, key) {
        val.typeText = val.type=='1'?t('message.correctiveSafetyTalk'):t('message.supportiveSafetyTalk')
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.targetText = val.targetDeptName
        else if(val.targetType == '3') val.targetText = val.targetMemberName
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })

      if(isGoodType.value == 'Y')
        items.value = _.filter(allItems.value, {type:'2'})
      else
        items.value = allItems.value
    },
    (error) => {
      isLoading.value = false
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickNormal = ()=>{
  storeRef.timelineType.value = typeModel.value
  utils.movePage('/actionManagement')
}

const onClickInitFilter=()=>{
  startDate.value = ''
  endDate.value = ''
  isGoodType.value = ''
  typeModel.value = '1'
  deptModel.value = ''
  posModel.value = ''
  monitoringModel.value = ''
  behaviorModel.value = ''
  shiftModel.value = ''
}

const waitForImages = async (container: HTMLElement) => {
  const images = Array.from(container.querySelectorAll('img'));

  await Promise.all(
    images.map((img) => {
      return new Promise<void>((resolve) => {
        if (img.complete && img.naturalWidth > 0) {
          resolve();
          return;
        }

        const done = () => resolve();

        img.onload = done;
        img.onerror = done;

        setTimeout(resolve, 2000);
      });
    })
  );
};

//37/2025-12-30/4407d248-58d0-4030-8d59-b95216e40d19.PNG
const onClickDownload = async () => {
  isLoading.value = true;
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';
  tempDiv.style.width = '1200px'; // 3열 배치를 위해 너비를 좀 더 확보
  tempDiv.style.backgroundColor = 'white';
  document.body.appendChild(tempDiv);

  const chunkSize = 15; // 한 페이지에 9개 (3열 3행)

  try {
    for (let i = 0; i < items.value.length; i += chunkSize) {
      const chunk = items.value.slice(i, i + chunkSize);

      // 3열 그리드 레이아웃
      tempDiv.innerHTML = `
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; padding: 20px; background: white;">
          ${chunk.map(item => {
        const getInfo = (val) => val ? val : t('message.noInfo');
        const isType1 = item.type === '1';

        return `
            <div style="padding: 15px; border: 1px solid #e0e0e0; border-radius: 8px; font-family: 'Malgun Gothic', sans-serif; background: white; display: flex; flex-direction: column;">
              <div style="width: 100%; height: 140px; overflow: hidden; border-radius: 6px; background: #f5f5f5; margin-bottom: 10px;">
                <img src="${utils.getBaseUrl('timeline', item.timelineImages?.[0]?.filePath)}"
                     style="width:100%; height:100%; object-fit:cover; object-position:center;" crossorigin="anonymous" loading="eager">
              </div>

              <div style="border-bottom: 1px solid #f0f0f0; padding-bottom: 8px; margin-bottom: 8px;">
                <div style="font-size: 12px; color: #333; font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  ${getInfo(item.memberName)} / ${getInfo(item.deptName)}
                </div>
                <div style="font-size: 11px; color: #999; margin-top: 2px;">${item.regDateFormat}</div>
              </div>

              <div style="font-size: 11px; line-height: 1.4; color: #444;">
                <div style="margin-bottom: 4px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                  <b style="color: #666;">${isType1 ? t('message.specificSituation') : t('message.praiseReason')}:</b>
                  ${item.situation}
                </div>

                ${isType1 ? `
                  <div style="margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><b style="color: #666;">${t('message.location')}:</b> ${item.placeName}</div>
                  <div style="margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><b style="color: #666;">${t('message.progressStatus')}:</b> <span style="color: #ff5252;">${item.statusText}</span></div>
                ` : ''}

                <div style="margin-top: 4px; font-size: 10px; color: #777; border-top: 1px dashed #eee; pt: 4px;">
                  <b>${isType1 ? t('message.correctiveActionTarget') : t('message.praiseTarget')}:</b> ${item.targetText}
                </div>
              </div>
            </div>
          `}).join('')}
        </div>
      `;

      // 이미지 로드 대기
      await waitForImages(tempDiv);
      await new Promise(requestAnimationFrame);
      /*
      const images = tempDiv.querySelectorAll('img');
      await Promise.all(Array.from(images).map(img => {
        return new Promise<void>(res => {
          if (img.complete) res();
          else {
            img.onload = () => res();
            img.onerror = () => res();
          }
        });
      }));
       */

      // 캡처 (9개를 한 번에)
      const canvas = await html2canvas(tempDiv, {
        useCORS: true,
        scale: 1.5, // 9개면 이미지가 작아지므로 1.5배가 적당함
        logging: false
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.5);

      if (i > 0) pdf.addPage();

      // A4 한 페이지에 꽉 차게 그리기 (여백 5mm 정도 확보)
      const imgWidth = pageWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 5, 5, imgWidth, imgHeight);

      // 메모리 정리
      canvas.width = 0; canvas.height = 0;
    }

    pdf.save('timeline_report.pdf');
  } catch (err) {
    console.error(err);
  } finally {
    document.body.removeChild(tempDiv);
    isLoading.value = false;
  }
};

const onClickDownload2 = async () => {
  isLoading.value = true;
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';
  tempDiv.style.width = '1200px';
  tempDiv.style.backgroundColor = 'white';
  document.body.appendChild(tempDiv);

  try {
    const itemsPerPage = 1;

    for (let i = 0; i < items.value.length; i += itemsPerPage) {
      const chunk = items.value.slice(i, i + itemsPerPage);

      tempDiv.innerHTML = chunk.map(item => `
        <div class="container main pdf-box">
          <div class="content">
            <div class="content-box bg-none" style="margin-bottom: 20px; font-family: 'Malgun Gothic', sans-serif;">
              <div class="content-inner-box-wrap">
                <div class="content-inner-box">
                  <div class="form-wrap">
                    <div class="form-group col-ty">
                      <div class="tit-group">
                        <div class="tit02">${t('message.detailedInfo')}</div>
                      </div>

                      ${item.type === '1' ? `
                      <div class="form-row"><div class="txt-tit">${t('message.behavior')}</div><div class="row">${item.behaviorTitle || ''}</div></div>
                      <div class="form-row"><div class="txt-tit">${t('message.location')}</div><div class="row">${item.placeName || ''}</div></div>
                      <div class="form-row"><div class="txt-tit">${t('message.cause')}</div><div class="row">${item.cause || ''}</div></div>
                      <div class="form-row"><div class="txt-tit">${t('message.correctiveActionContent')}</div><div class="row">${item.action || ''}</div></div>
                      ` : ''}

                      <div class="form-row"><div class="txt-tit">${item.type === '1' ? t('message.specificSituation') : t('message.praiseReason')}</div><div class="row">${item.situation}</div></div>
                      <div class="form-row"><div class="txt-tit">${item.type === '1' ? t('message.correctiveActionTarget') : t('message.praiseTarget')}</div><div class="row">${item.targetText}</div></div>
                      <div class="form-row"><div class="txt-tit">${t('message.registrationDate')}</div><div class="row">${dayjs(item.regDate).format('YYYY-MM-DD HH.mm.ss')}</div></div>

                      <div class="img-slider02">
                      ${item.timelineImages?.map(img => `<div class="img-wrap ty01"><img src="${utils.getBaseUrl('timeline', img.filePath)}"></div>`).join('')}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content-inner-box ty02">
                  <div class="tit-group mo-ty01">
                    <h4 class="tit">${t('message.history')}</h4>
                  </div>
                  <div class="history-group">
                    ${item.timelineLogs?.map(log => `
                      <div class="box">
                        <div class="txt-group">
                          <div class="txt">${dayjs(log.regDate).format('YYYY-MM-DD HH:mm:ss')}</div>
                          <div class="txt2">
                            <div class="tag-icon-group">
                            ${log.changeType === '1' ? ` <div class="tag-icon ty01">${t('message.create')}</div> ` : ''}
                            ${log.changeType === '2' ? ` <div class="tag-icon ty02" >${t('message.comment')}</div> ` : ''}
                            ${log.changeType === '3' ? ` <div class="tag-icon ty03" >
                                ${log.changeStatus=='1'?t('message.ready'):''}
                                ${log.changeStatus=='2'?t('message.inProgress'):''}
                                ${log.changeStatus=='3'?t('message.onHold'):''}
                                ${log.changeStatus=='4'?t('message.complete'):''}
                              </div>
                             ` : ''}
                            ${log.changeType === '4' ? `<div class="tag-icon ty04" >${t('message.send')}</div> ` : ''}
                            ${log.changeType === '5' ? `<div class="tag-icon ty02" >${t('message.deleteComment')}</div> ` : ''}
                            </div>
                            <span class="t1">${log.memberName?log.memberName:t('message.noInfo') } / ${ log.deptName?log.deptName:t('message.noInfo') } / ${ log.posName?log.posName:t('message.noInfo') }</span>
                            ${log.changeType === '4' ? `
                            <div class="inner">
                              <span class="ico-arr" aria-hidden="true"></span>
                              ${log.targetType === '3' ? ` <span class="t2">${ log.targetMemberName } / ${ log.targetDeptName } / ${ log.targetPosName }</span> ` : ''}
                              ${log.targetType === '2' ? ` <span class="t2">${ log.targetName }</span> ` : ''}
                            </div>
                            ` : ''}
                          </div>
                        </div>
                        ${log.comment || (log.changeStatus=='3'&&log.changeType=='3') ? `
                        <div class="txt-group2">
                          <div class="txt">${log.changeStatus=='3'&&log.changeType=='3'?log.logMsg:log.comment}</div>
                          ${log.filePath ? `
                          <div class="img-group">
                            <div class="item">
                              <img src="${utils.getBaseUrl('comment', log.filePath)}" style="width:80px;height:80px;object-fit:cover;" crossorigin="anonymous">
                            </div>
                          </div>
                          ` : ''}
                        </div>
                        ` : ''}
                      </div>
                    `).join('')}
                  </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      `).join('');

      // 이미지 로드 대기
      await waitForImages(tempDiv);
      await new Promise(requestAnimationFrame);
      /*
      const images = tempDiv.querySelectorAll('img');
      await Promise.all(Array.from(images).map(img => new Promise<void>(res => {
        if (img.complete) res();
        else { img.onload = () => res(); img.onerror = () => res(); }
      })));
       */

      // html2canvas 캡처
      const canvas = await html2canvas(tempDiv, { useCORS: true, scale: 1.5, logging: false });
      const imgData = canvas.toDataURL('image/jpeg', 0.5);

      if (i > 0) pdf.addPage();

      const imgWidth = pageWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'JPEG', 5, 5, imgWidth, imgHeight);

      canvas.width = 0; canvas.height = 0;
    }

    pdf.save('timeline_report.pdf');
  } catch (err) {
    console.error(err);
  } finally {
    document.body.removeChild(tempDiv);
    isLoading.value = false;
  }
};


// 이미지를 로드하는 헬퍼 함수 (CORS 대응)
const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // CORS 설정
    img.src = url;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
};

const deleteAmDialog=(idx)=>{
  _.remove(items.value, item =>item.idx == idx)
}
</script>


<style lang="scss">
</style>
